import React, { useState, useRef, useEffect } from "react";

const InitialTimer = ({ color, countDown }) => {
  const Ref = useRef(null);
  const timeCounter = color === "#00A650" ? countDown.convertedFormat : "3:00";
  const [timer, setTimer] = useState("0:00");

  const getRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    return {
      total,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, minutes, seconds } = getRemaining(e);
    if (total >= 0) {
      setTimer(
        (minutes > 9 ? minutes : minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds),
      );
    }
  };

  const clearTimer = (e) => {
    setTimer(timeCounter);
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const handleTime = () => {
    let time = new Date();
    const adjustedTime = color === "#00A650" ? countDown.converted : 180;
    time.setSeconds(time.getSeconds() + Number(adjustedTime));
    return time;
  };

  useEffect(() => {
    clearTimer(handleTime());
    // eslint-disable-next-line
  }, []);

  useEffect(() => () => setTimer(null), []);

  return (
    <div className="Timer-container">
      <h2
        className="Timer-display"
        style={{
          color: color ? color : "white",
        }}
      >
        {timer}
      </h2>
    </div>
  );
};

export default InitialTimer;
